import React from 'react';

export const hexToRgba = (hex: string, alpha: number) => {
  const clean = hex.replace('#', '');
  const full = clean.length === 3
    ? clean.split('').map(c => c + c).join('')
    : clean;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
};

export const getInitials = (firstName?: string, lastName?: string) =>
  ((firstName?.[0] ?? '') + (lastName?.[0] ?? '')).toUpperCase() || '?';

/** Colored initials avatar circle */
export const renderAvatar = (initials: string, color: string) => (
  <div style={{
    width: 28, height: 28, borderRadius: '50%',
    backgroundColor: hexToRgba(color, 0.15),
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 10, fontWeight: 500, color, flexShrink: 0, letterSpacing: '0.03em',
  }}>
    {initials}
  </div>
);

/** Contact name cell: avatar + "First Last" */
export const renderContactName = (c: any) => (
  <div className="flex items-center gap-[10px]">
    {renderAvatar(getInitials(c.firstName, c.lastName), c.contactType?.color ?? '#6366f1')}
    <span style={{ fontWeight: 500 }}>{c.firstName} {c.lastName}</span>
  </div>
);

/** Organisation name cell: initials avatar + name */
export const renderOrgName = (o: any) => (
  <div className="flex items-center gap-[10px]">
    {renderAvatar(
      (o.name ?? '').substring(0, 2).toUpperCase() || '?',
      o.organisationType?.color ?? '#6366f1',
    )}
    <span style={{ fontWeight: 500 }}>{o.name}</span>
  </div>
);

/** Plain text type cell */
export const renderTypeName = (item: any, key = 'name') =>
  <>{item?.[key] ?? '—'}</>;

/** Active status dot */
export const renderActiveStatus = (isActive: boolean) => (
  <span className={isActive ? 'text-green-400' : 'text-[var(--text-color-calendar-week)]'}>
    {isActive ? '●' : '○'}
  </span>
);
